export function buildCategoryTree(categories = []) {
  const byId = new Map();
  const childrenMap = new Map(); // id => child array
  const roots = [];

  categories.forEach((c) => {
    byId.set(String(c._id), c);
    childrenMap.set(String(c._id), []);
  });

  categories.forEach((c) => {
    const pid = c.parentId ? String(c.parentId) : null;
    if (pid && childrenMap.has(pid)) {
      childrenMap.get(pid).push(c);
    } else if (!pid) {
      roots.push(c);
    }
  });

  return { roots, byId, childrenMap };
}

export function computeAllowedCategorySet(categories = [], scopeIds = []) {
  const { byId, childrenMap } = buildCategoryTree(categories);
  const scopes = (scopeIds || []).map(String).filter(Boolean);
  if (!scopes.length) {
    // بدون اسکوپ → همه مجازند
    return new Set(categories.map((c) => String(c._id)));
  }

  const allowed = new Set();
  const visit = (id) => {
    const sid = String(id);
    if (allowed.has(sid)) return;
    if (!byId.has(sid)) return;
    allowed.add(sid);
    const kids = childrenMap.get(sid) || [];
    kids.forEach((ch) => visit(ch._id));
  };

  scopes.forEach((id) => visit(id));
  return allowed;
}
